/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {AdminResourceRouteContext, readAdminResourceRouteContext} from './admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-admin-resource-context-route-page',
  template: `
    <adn-admin-resource-context-actions
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [isNew]="context.isNew"
      [readOnly]="context.readOnly"
      [blockDelete]="context.blockDelete"
      [confirmation]="context.confirmation"
      [copyConfig]="context.copyConfig">
    </adn-admin-resource-context-actions>
  `
})
export class AdminResourceContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
